import imageSliderService from "../services/image-slider.service"
import { FETCH_IMAGES, IMAGES_FAIL, IMAGES_SUCCESS, IMAGES_SUCCESS_ACTION } from "./type"

export const fetchImages = (reference) => (dispatch) =>{
    dispatch({type:FETCH_IMAGES})
    return imageSliderService.getImages(reference).then((response)=>{
        const parsedImages = response.map((el) => {
            const byteString = window.atob(el.data.split(',')[1]);
            const mimeString = el.data.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const dataBlob = new Blob([ab], { type: mimeString });
            const imageUrl = URL.createObjectURL(dataBlob);
            return { url: imageUrl, alt: el.name, size:dataBlob.size };
        });
        dispatch({type:IMAGES_SUCCESS,payload:parsedImages})
        return Promise.resolve()
    },
    (error)=>{
        dispatch({type:IMAGES_FAIL, payload:error.message})
        return Promise.reject()
    }
)
}

export const createImage = (image,is_image) => (dispatch) =>{
    return imageSliderService.uploadImage(image,is_image).then(()=>{
        dispatch({type:IMAGES_SUCCESS_ACTION})
        return Promise.resolve()
    },
    (error)=>{
        dispatch({type:IMAGES_FAIL, payload:error.message})
        return Promise.reject()
    }
)
}

export const updateImage = (image,is_image) => (dispatch) =>{
    return imageSliderService.updateImage(image,is_image).then((resposne)=>{
        console.log("this is reponse",resposne)
        dispatch({type:IMAGES_SUCCESS_ACTION})
        return Promise.resolve()
    },
    (error)=>{
        dispatch({type:IMAGES_FAIL, payload:error.message})
        return Promise.reject()
    }
)
}
export const deleteImageDispatch = (image,is_image) => (dispatch) =>{
    return imageSliderService.deleteImage(image,is_image).then(()=>{
        dispatch({type:IMAGES_SUCCESS_ACTION})
        return Promise.resolve()
    },
    (error)=>{
        dispatch({type:IMAGES_FAIL, payload:error.message})
        return Promise.reject()
    }
)
}